// Snowball (MOB-5). PURE (ENG-1). A snow golem's thrown snowball; flies with the
// shared arrow integrator (EntitySystem.tickProjectiles) and knocks back the mob
// it strikes for a token point of damage (GOLEM.SNOWBALL_DAMAGE, a playability
// deviation — vanilla snowballs are damageless to most mobs).
import { GOLEM } from '../../config';
import type { Entity, EntitySystem } from '../entity';
import { solveAim } from './shared';

/** Throw a snowball from `shooter` toward (tx,ty,tz). */
export function fireSnowballAt(sys: EntitySystem, shooter: Entity, tx: number, ty: number, tz: number): void {
  const sx = shooter.x, sy = shooter.y + 1.2, sz = shooter.z;
  const v = solveAim(tx - sx, ty - sy, tz - sz, GOLEM.SNOWBALL_SPEED);
  sys.spawnProjectile('snowball', sx, sy, sz, v.x, v.y, v.z, shooter.id, GOLEM.SNOWBALL_DAMAGE);
}
